// import React from 'react';

// const IconLoader = () => (
//   <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
//     <title>Loader Logo</title>
//     <g>
//       <g id="B" transform="translate(11.000000, 5.000000)"></g>
//       <path
//         stroke="currentColor"
//         strokeWidth="5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M 50, 5
//                   L 11, 27
//                   L 11, 72
//                   L 50, 95
//                   L 89, 73
//                   L 89, 28 z"
//       />
//     </g>
//     <text x="37" y="68" fill="currentColor" fontSize="55px" fontFamily="Lucida Console">
//       P
//     </text>
//   </svg>
// );

// export default IconLoader;


// import React from 'react';

// const IconLoader = () => {
//   // Function to generate perfect heptagon points as path string
//   const generateHeptagonPath = (cx, cy, r) => {
//     let path = '';
//     for (let i = 0; i < 7; i++) {
//       const angle = (2 * Math.PI * i) / 7 - Math.PI / 2; // start from top
//       const x = cx + r * Math.cos(angle);
//       const y = cy + r * Math.sin(angle);
//       path += `${i === 0 ? 'M' : 'L'} ${x},${y} `;
//     }
//     path += 'Z'; // Close path
//     return path;
//   };

//   const heptagonPath = generateHeptagonPath(50, 50, 45);

//   return (
//     <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
//       <title>Loader Logo</title>
//       <g>
//         <path
//           stroke="currentColor"
//           strokeWidth="5"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           fill="none"
//           d={heptagonPath}
//         />
//       </g>
//       <text
//         x="50"
//         y="60"
//         fill="currentColor"
//         fontSize="24px"
//         fontFamily="Inter, system-ui, sans-serif"
//         fontWeight="800"
//         textAnchor="middle"
//       >
//         BK
//       </text>
//     </svg>
//   );
// };

// export default IconLoader;


// import React from 'react';

// const IconLoader = () => (
//   <svg
//     id="logo"
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 1440 810"
//     fill="none">
//     <title>BK Loader</title>
//     <g transform="translate(353, 47)">
//       {/* THE OUTER FRAME - This will be "drawn" via strokeDashoffset */}
//       <path
//         id="frame"
//         stroke="currentColor"
//         strokeWidth="15"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M 367.148 7.144 L 78.542 146.136 L 7.246 458.257 L 206.917 708.75 L 527.191 708.75 L 726.863 458.257 L 655.562 146.136 Z"
//       />

//       {/* THE INNER LOGO (BK) - This will fade in */}
//       <g id="B" fill="currentColor" style={{ opacity: 0 }}>
//         {/* The "K" part */}
//         <path d="M 646.796 554.703 L 576.457 554.703 L 472.781 419.5 L 430.308 465.175 L 430.308 554.703 L 373.222 554.703 L 373.222 344.511 L 430.308 305.386 L 524.367 240.91 L 430.308 329.628 L 430.308 394.375 L 567.781 240.91 L 637.656 240.91 L 512.058 379.3 Z" />
//         {/* The "B" part */}
//         <path d="M 316.492 309.007 C 344.355 293.929 360.792 271.554 360.792 239.582 C 360.792 193.921 322.429 161.031 268.082 161.031 L 114.152 161.031 L 114.152 474.808 L 149.375 474.808 L 87.472 536.425 L 177.371 474.808 L 249.339 425.484 L 170.792 425.484 L 170.792 335.957 L 262.589 335.957 C 293.402 335.957 315.207 354.382 315.566 380.093 L 362.273 348.07 C 352.445 332.144 336.773 318.773 316.492 309.007 Z M 254.378 289.367 L 170.792 289.367 L 170.792 210.355 L 254.378 210.355 C 282.242 210.355 302.328 226.792 302.328 250.093 C 302.328 272.933 282.23 289.367 254.378 289.367 Z" />
//       </g>
//     </g>
//   </svg>
// );

// export default IconLoader;

// // Inside Loader.js animate function
// loader
//   .add({
//     targets: '#logo #frame', // Draws your heptagon frame
//     delay: 300,
//     duration: 1500,
//     easing: 'easeInOutQuart',
//     strokeDashoffset: [anime.setDashoffset, 0],
//   })
//   .add({
//     targets: '#logo #B', // Fades in the BK letters
//     duration: 700,
//     easing: 'easeInOutQuart',
//     opacity: 1,
//   })
//   // ... keep the rest of your scale and z-index animations the same


// import React from 'react';

// const IconLoader = () => (
//   <svg
//     id="logo"
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 1440 810"
//     fill="none">
//     <title>BK Loader</title>
//     <g transform="translate(353, 47)">
//       {/* THE OUTER FRAME - This will be "drawn" via strokeDashoffset */}
//       <path
//         id="frame"
//         stroke="currentColor"
//         strokeWidth="15"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M 367.148 7.144 L 78.542 146.136 L 7.246 458.257 L 206.917 708.75 L 527.191 708.75 L 726.863 458.257 L 655.562 146.136 Z"
//       />

//       {/* THE INNER LOGO (BK) - This will fade in after the frame draws */}
//       <g id="B" fill="currentColor" style={{ opacity: 0 }}>
//         {/* The "K" part */}
//         <path d="M 646.796 554.703 L 576.457 554.703 L 472.781 419.5 L 430.308 465.175 L 430.308 554.703 L 373.222 554.703 L 373.222 344.511 L 430.308 305.386 L 524.367 240.91 L 430.308 329.628 L 430.308 394.375 L 567.781 240.91 L 637.656 240.91 L 512.058 379.3 Z" />
//         {/* The "B" part */}
//         <path d="M 316.492 309.007 C 344.355 293.929 360.792 271.554 360.792 239.582 C 360.792 193.921 322.429 161.031 268.082 161.031 L 114.152 161.031 L 114.152 474.808 L 149.375 474.808 L 87.472 536.425 L 177.371 474.808 L 249.339 425.484 L 170.792 425.484 L 170.792 335.957 L 262.589 335.957 C 293.402 335.957 315.207 354.382 315.566 380.093 L 362.273 348.07 C 352.445 332.144 336.773 318.773 316.492 309.007 Z M 254.378 289.367 L 170.792 289.367 L 170.792 210.355 L 254.378 210.355 C 282.242 210.355 302.328 226.792 302.328 250.093 C 302.328 272.933 282.23 289.367 254.378 289.367 Z" />
//       </g>
//     </g>
//   </svg>
// );

// export default IconLoader;

import React from 'react';

const IconLoader = () => (
  <svg
    id="logo"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1440 810"
    fill="none">
    <title>BK Loader</title>
    <g transform="translate(353, 47)">
      
      {/* 1. The Navy Background - Fades in with the letters */}
      <path 
        id="bg-shape"
        fill="#0f172a" 
        style={{ opacity: 0 }}
        d="M 367.148438 7.144531 L 78.542969 146.136719 L 7.246094 458.257812 L 206.917969 708.75 L 527.191406 708.75 L 726.863281 458.257812 L 655.5625 146.136719 Z" 
      />

      {/* 2. The Blue Outline - This part gets "Drawn" */}
      <path
        id="frame"
        stroke="#38bdf8"
        strokeWidth="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 367.148 7.144 L 78.542 146.136 L 7.246 458.257 L 206.917 708.75 L 527.191 708.75 L 726.863 458.257 L 655.562 146.136 Z"
      />

      {/* 3. The Letters Group - Fades in */}
      <g id="B" style={{ opacity: 0 }}>
        {/* K part - Slate */}
        <path fill="#f1f5f9" d="M 646.796 554.703 L 576.457 554.703 L 472.781 419.5 L 430.308 465.175 L 430.308 554.703 L 373.222 554.703 L 373.222 344.511 L 430.308 305.386 L 524.367 240.91 L 430.308 329.628 L 430.308 394.375 L 567.781 240.91 L 637.656 240.91 L 512.058 379.3 Z" />
        {/* B part - Blue */}
        <path fill="#38bdf8" d="M 316.492 309.007 C 344.355 293.929 360.792 271.554 360.792 239.582 C 360.792 193.921 322.429 161.031 268.082 161.031 L 114.152 161.031 L 114.152 474.808 L 149.375 474.808 L 87.472 536.425 L 177.371 474.808 L 249.339 425.484 L 170.792 425.484 L 170.792 335.957 L 262.589 335.957 C 293.402 335.957 315.207 354.382 315.566 380.093 L 362.273 348.07 C 352.445 332.144 336.773 318.773 316.492 309.007 Z M 254.378 289.367 L 170.792 289.367 L 170.792 210.355 L 254.378 210.355 C 282.242 210.355 302.328 226.792 302.328 250.093 C 302.328 272.933 282.23 289.367 254.378 289.367 Z" />
      </g>
    </g>
  </svg>
);

export default IconLoader;